import React, { Fragment, useEffect } from "react";
import * as s from "./Dashboard.styles";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../store/actions/index";

// shared
import Spinner from "../../../components/shared/spinner/Spinner";

// components
import ClientsComponent from "../../../components/admin/clients/ClientsComponent";
import ManagersComponent from "../../../components/admin/managers/ManagersComponent";

const Dashboard = () => {
  const dispatch = useDispatch();
  const clientsLoading = useSelector((state) => state.forClients.loading);
  const managersLoading = useSelector((state) => state.forAdmins.loading);

  useEffect(() => {
    dispatch(actions.fetchUsers(1, 10));
  }, []);

  useEffect(() => {
    dispatch(actions.fetchAdmins(1, 10));
  }, []);

  return (
    <s.DashboardContainer>
      {clientsLoading === false && managersLoading === false ? (
        <Fragment>
          <s.ClientsContainer>
            <ClientsComponent />
          </s.ClientsContainer>
          <s.AdminsContainer>
            <ManagersComponent />
          </s.AdminsContainer>
        </Fragment>
      ) : (
        <s.SpinnerContainer>
          <Spinner />
        </s.SpinnerContainer>
      )}
    </s.DashboardContainer>
  );
};

export default Dashboard;
